import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import { theme } from './theme';
import './index.css';
import App from './App';
import Todo from "./routes/Todo";
import LiveStream from "./routes/LiveStream";
import VideoLibrary from "./routes/VideoLibrary";

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<App />}>
            <Route path="todos" element={<Todo />} />
            <Route path="livestream" element={<LiveStream />} />
            <Route path="videos" element={<VideoLibrary />} />
            <Route
              path="*"
              element={
                <main style={{ padding: "1rem" }}>
                  <p>There's nothing here!</p>
                </main>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
